import * as React from 'react';

import styles from './TableRow/table-row.module.css';

interface TableColumnProps {
    width: string;
    flex?: number | string;
    style?: React.CSSProperties;
    children: React.ReactNode;
}

function TableColumn({ children, width, flex, style = {} }: TableColumnProps): React.ReactElement<TableColumnProps> {
    return (
        <div
            className={styles.TableRowTextWrapper}
            style={
                flex
                    ? {
                          ...style,
                          flex,
                          width,
                      }
                    : {
                          ...style,
                          width,
                      }
            }
        >
            {children}
        </div>
    );
}

export default TableColumn;
